/**
 * Collapses long PDP descriptions (.av-description__content, clamped via CSS
 * max-height) behind a Show more / Show less button. The button only
 * appears when the content actually overflows its collapsed height.
 */
document.querySelectorAll('.av-description').forEach(function (wrapper) {
  var content = wrapper.querySelector('.av-description__content');
  var toggle = wrapper.querySelector('.av-description__toggle');
  if (!content || !toggle) return;

  requestAnimationFrame(function () {
    if (content.scrollHeight > content.clientHeight + 4) {
      toggle.hidden = false;
    }
  });

  var moreLabel = toggle.querySelector('.av-description__toggle-label-more');
  var lessLabel = toggle.querySelector('.av-description__toggle-label-less');

  toggle.addEventListener('click', function () {
    var expanded = content.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', expanded);
    if (moreLabel) moreLabel.hidden = expanded;
    if (lessLabel) lessLabel.hidden = !expanded;
  });
});
